// export function Navbar() {
//   return (
//     <nav className="flex justify-between items-center px-6 py-4 shadow-md bg-white sticky top-0 z-50">
//       <h1 className="text-2xl font-bold text-blue-600">TechFix Computers</h1>
//       <ul className="flex gap-6 font-medium">
//         <li>
//           <a href="#home" className="hover:text-blue-600">
//             Home
//           </a>
//         </li>
//         <li>
//           <a href="#services" className="hover:text-blue-600">
//             Services
//           </a>
//         </li>
//         <li>
//           <a href="#products" className="hover:text-blue-600">
//             Products
//           </a>
//         </li>
//         <li>
//           <a href="#about" className="hover:text-blue-600">
//             About
//           </a>
//         </li>
//         <li>
//           <a href="#contact" className="hover:text-blue-600">
//             Contact
//           </a>
//         </li>
//       </ul>
//     </nav>
//   );
// }

// Navbar.tsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/all-services", label: "Services" },
    { to: "/all-products", label: "Products" },
    { to: "/about-us", label: "About" },
    { to: "/contact-us", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="flex justify-between items-center px-6 py-4 bg-white sticky top-0 z-50 shadow-sm">
      {/* Logo + Full Brand Name */}
      <Link to="/" className="flex items-center gap-3 group">
        <div className="w-11 h-11 rounded-full overflow-hidden shadow-sm group-hover:shadow-md transition-shadow">
          <img
            src="/images/logo.jpg"
            alt="Kevmark"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="text-left">
          <h1 className="text-xl font-bold text-blue-700 leading-none">
            Kevmark
          </h1>
          <p className="text-xs text-blue-600 font-medium leading-none">
            Investments
          </p>
        </div>
      </Link>

      {/* Desktop Menu */}
      <ul className="hidden md:flex gap-7 font-medium text-gray-700">
        {navLinks.map(({ to, label }) => (
          <li key={to}>
            <Link
              to={to}
              className={`relative pb-1 transition-colors duration-200 hover:text-blue-600 ${
                isActive(to) ? "text-blue-700 font-semibold" : ""
              }`}
            >
              {label}
              {/* Active Bottom Border */}
              {isActive(to) && (
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-700 rounded-full" />
              )}
            </Link>
          </li>
        ))}
      </ul>

      {/* Mobile Toggle */}
      <button
        onClick={toggleMenu}
        className="md:hidden p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition"
        aria-label="Toggle menu"
      >
        {isOpen ? <FaTimes size={26} /> : <FaBars size={26} />}
      </button>

      {/* Mobile Full-Screen Menu */}
      {isOpen && (
        <ul className="fixed inset-0 bg-white flex flex-col items-center justify-center md:hidden gap-10 z-40 text-xl font-medium">
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                onClick={toggleMenu}
                className={`relative pb-1 transition-colors hover:text-blue-600 ${
                  isActive(to) ? "text-blue-700 font-semibold" : "text-gray-700"
                }`}
              >
                {label}
                {isActive(to) && (
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-700 rounded-full" />
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}

export default Navbar;
// import { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaBars,
//   FaTimes,
//   // FaFacebook,
//   // FaTwitter,
//   // FaInstagram,
// } from "react-icons/fa";

// export function Navbar() {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => setIsOpen(!isOpen);

//   return (
//     <nav className="flex justify-between items-center px-6 py-4 shadow-md bg-white sticky top-0 z-50">
//       <h1 className="text-2xl font-bold text-blue-600">
//         Kevmark Investments Limited
//       </h1>

//       {/* Desktop Menu */}
//       <ul className="hidden md:flex gap-6 font-medium">
//         <li>
//           {/* <a href="#home" className="hover:text-blue-600">
//             Home
//           </a> */}
//           <Link to="/" className="hover:text-blue-600">
//             Home
//           </Link>
//         </li>
//         <li>
//           {/* <a href="#services" className="hover:text-blue-600">
//             Services
//           </a> */}
//           <Link to="/all-services" className="hover:text-blue-600">
//             Services
//           </Link>
//         </li>
//         <li>
//           {/* <a href="#products" className="hover:text-blue-600">
//             Products
//           </a> */}
//           <Link to="/all-products" className="hover:text-blue-600">
//             Products
//           </Link>
//         </li>
//         <li>
//           {/* <a href="#about" className="hover:text-blue-600">
//             About
//           </a> */}
//           <Link to="/about-us" className="hover:text-blue-600">
//             About
//           </Link>
//         </li>
//         <li>
//           {/* <a href="#contact" className="hover:text-blue-600">
//             Contact
//           </a> */}
//           <Link to="/contact-us" className="hover:text-blue-600">
//             Contact
//           </Link>
//         </li>
//       </ul>

//       {/* Mobile Menu Button */}
//       <div className="md:hidden z-50 cursor-pointer" onClick={toggleMenu}>
//         {isOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
//       </div>

//       {/* Mobile Full-Screen Menu */}
//       {isOpen && (
//         <ul className="fixed inset-0 bg-white flex flex-col items-center justify-center md:hidden gap-8 z-40">
//           <li>
//             <a
//               href="#home"
//               className="hover:text-blue-600"
//               onClick={toggleMenu}
//             >
//               Home
//             </a>
//           </li>
//           <li>
//             <a
//               href="#services"
//               className="hover:text-blue-600"
//               onClick={toggleMenu}
//             >
//               Services
//             </a>
//           </li>
//           <li>
//             <a
//               href="#products"
//               className="hover:text-blue-600"
//               onClick={toggleMenu}
//             >
//               Products
//             </a>
//           </li>
//           <li>
//             <a
//               href="#about"
//               className="hover:text-blue-600"
//               onClick={toggleMenu}
//             >
//               About
//             </a>
//           </li>
//           <li>
//             <a
//               href="#contact"
//               className="hover:text-blue-600"
//               onClick={toggleMenu}
//             >
//               Contact
//             </a>
//           </li>
//         </ul>
//       )}
//     </nav>
//   );
// }

// export default Navbar;
